export default __webpack_public_path__ + "static/media/menu_3_support_3.cfc92f4f.svg";